/**
 * It support by the md-panel directive for opening md-panel menu.
 */
export class PanelMenuController {
  public static $inject = ['mdPanelRef', '$filter', 'onFetch', 'paymentDateRange'];

  public fromDate: Date;
  public toDate: Date;
  public maxDate: Date;
  public isCustomRangeActive: boolean;
  public selectedPaymentDateRange: string;
  public selectedPaymentDateRangeKey: string;
  public paymentDateRangeList: {};

  constructor(
    public mdPanelRef: ng.material.IPanelRef,
    private $filter: ng.IFilterService,
    public onFetch: Function,
    public paymentDateRange: InterACT.Interfaces.IPaymentDateRange
  ) {
    this.activate();
  }

  /**
   * Returns true when custom range is not active and the key is selected
   * @param key the key representing a date
   * @returns true when not a custom date range and the key matches selectedPaymentDateRangeKey
   */
  public isKeySelected = (key: string) => {
    return !this.isCustomRangeActive && key === this.selectedPaymentDateRangeKey;
  }

  /**
    * A method which is used to select the selected payment date range.
    *
    * @param key for text of Payment Date Range
    * @param value for value of Payment Date Range
    */
  public selectPaymentDateRange = (key: string, value: Array<moment.Moment>) => {
    this.paymentDateRange.startDate = value[0].toDate();
    this.paymentDateRange.endDate = value[1].toDate();
    this.paymentDateRange.selectedPaymentDateRange = key;
    this.paymentDateRange.selectedPaymentDateRangeKey = key;
    this.paymentDateRange.isCustomRangeActive = false;
    this.onFetch();
    this.closeMdPanel();
  }

  /**
   * A method which is used to update start and end dates.
   */
  public updateStartEndPaymentDate = () => {
    this.paymentDateRange.startDate = this.fromDate;
    this.paymentDateRange.endDate = this.toDate;
    this.paymentDateRange.selectedPaymentDateRange = this.$filter('date')(this.paymentDateRange.startDate, 'dd MMM yyyy')
      + '-' + this.$filter('date')(this.paymentDateRange.endDate, 'dd MMM yyyy');
    this.paymentDateRange.isCustomRangeActive = true;
    this.onFetch();
  }

  /*
    * A method which is used to show and hide the custom range menu.
    */
  public toggleCustomRangeMenu = () => {
    this.isCustomRangeActive = !this.isCustomRangeActive;
  }

  /*
    * A method which is used to close the mdPanel.
    */
  private closeMdPanel = () => {
    this.mdPanelRef.close().then(() => {
      angular.element(document.querySelector('.menu-open-button')).focus();
    });
  }

  /*
    * A method which is used to initialize controller
    */
  private activate() {
    this.selectedPaymentDateRange = this.paymentDateRange.selectedPaymentDateRange;
    this.selectedPaymentDateRangeKey = this.paymentDateRange.selectedPaymentDateRange;
    this.isCustomRangeActive = this.paymentDateRange.isCustomRangeActive;
    this.paymentDateRangeList = this.getDateRanges();
    this.maxDate = new Date();
    if(this.paymentDateRange.isCustomRangeActive) {
      this.fromDate =  this.paymentDateRange.startDate;
      this.toDate = this.paymentDateRange.endDate;
    } else {
      this.fromDate = new Date(this.paymentDateRangeList['PAYMENT_DATE.LAST_30_DAYS'][0]);
      this.toDate = new Date();
    }
  }

  /**
    * To Display all dates ranges.
    * @returns The response object returned payment date start and end date.
    */
  private getDateRanges() {
    return {
      'PAYMENT_DATE.TODAY': [moment(), moment()],
      'PAYMENT_DATE.YESTERDAY': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'PAYMENT_DATE.LAST_7_DAYS': [moment().subtract(6, 'days'), moment()],
      'PAYMENT_DATE.LAST_30_DAYS': [moment().subtract(29, 'days'), moment()],
      'PAYMENT_DATE.THIS_MONTH': [moment().startOf('month'), moment().endOf('month')],
      'PAYMENT_DATE.LAST_MONTH': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
      'PAYMENT_DATE.THIS_YEAR': [moment().startOf('year'), moment()],
      'PAYMENT_DATE.LAST_YEAR': [moment().subtract(1, 'year').startOf('year'), moment().subtract(1, 'year').endOf('year')]
    };
  }
}